export default {
	"transSec.FailedToGetPaymentLink": "Failed to get payment link",
	"transSec.IDidntGetAPaymentToken": "I didn't get a payment token",
	"transSec.FailedToCreateAlipayPrepaidOrder": "Failed to create Alipay prepaid order!",
	"transSec.FailedToGetPaymentInformation": "Failed to get payment information",
	"transSec.return": "return",
	"transSec.AgreeAndContinue": "Agree and continue",
	"transSec.NoProductsSelected": "No products selected",
	"transSec.prompt": "prompt",
	"transSec.UntieTheBindingForTheTimeBeing": "Untie the binding for the time being",
	"transSec.UnbindTheAccount": "Unbind the account",
	"transSec.SorryThePriceHasChanged": "Sorry, the price has changed!",
	"transSec.SorryFailedToCreateOrder": "Sorry, failed to create order!",
	"transSec.RepeatPurchasePrompts": "Repeat purchase prompts",
	"transSec.ignore": "ignore",
	"transSec.ViewOrders": "View orders",
	"transSec.WeChatCanEnterTheAccessAfterAuthorizationRequestAuthorization": "WeChat can enter the access after authorization, request authorization...",
	"transSec.MarketplaceConfirmOrderPagePaymentMethodClick": "Marketplace confirm order page_Payment method click",
	"transSec.MarketplaceafterAddress": "Marketplace (after address)",
	"transSec.MarketplaceCashierPageOrderButton": "Marketplace cashier page_Order button",
	"transSec.TheSystemIsDeserting": "The system is deserting",
	"transSec.TheSystemIsDesertingPleaseTryAgainLater": "The system is deserting, please try again later",
	"transSec.PaymentFailed": "Payment failed!",
	"transSec.PaymentSuccessful": "Payment successful",
	"transSec.PaidSuccessfullyJumping": "Paid successfully, jumping...",
	"transSec.Wechat": "Wechat",
	"transSec.FlowerStaging": "Flower staging",
	"transSec.AlipayScanCodeToPay": "Alipay scan code to pay",
	"transSec.PleaseTryAgainIfTheQueryFails": "Please try again if the query fails",
	"transSec.IfThePaymentIsSuccessfulPleaseReturnToWeChatToContinueTheOperation": "If the payment is successful, please return to WeChat to continue the operation",
	"transSec.MarketplaceConfirmationOrderPagePaymentResultConfirmationPopUpWindow": "Marketplace Confirmation Order Page_Payment Result Confirmation Pop-up Window",
	"transSec.MallOrderConfirmationPageCouponRetentionPopUpWindowConfirmationButton": "Mall order confirmation page_Coupon retention pop-up window_Confirmation button",
	"transSec.AcceptAndUse": "Accept and use",
	"transSec.PickUpFailed": "Pick-up failed",
	"transSec.NoPaymentResultDetected": "No payment result detected",
	"transSec.IfYouHaveAlreadyPaidPleaseClickRefreshToQueryTheResults": "If you have already paid, please click Refresh to query the results",
	"transSec.Repayment": "Repayment",
	"transSec.MallCashierPagePaymentConfirmationPopUpconfirmButton": "Mall cashier page_Payment confirmation pop-up_confirm button",
	"transSec.flushed": "flushed",
	"transSec.MallOrderConfirmationPagePaymentResultConfirmationPopUpWindowCloseButton": "Mall order confirmation page_Payment result confirmation pop-up window_Close button",
	"transSec.divide": "divide",
	"transSec.timeLimit": "time limit",
	"transSec.0HandlingFees": "0 handling fees",
	"transSec.Fee¥¥": "Fee ¥ ¥ ",
	"transSec.PerIssue": "/ Per issue",
	"transSec.recommend": "recommend",
	"transSec.MarketplaceConfirmOrderPagecouponClick": "Marketplace confirm order page_coupon click",
	"transSec.PleaseConfirmThatYouHaveReadAndAgree": "Please confirm that you have read and agree",
	"transSec.UserServiceAgreement": "《User Service Agreement》",
	"transSec.OfferSelected": "Offer selected",
	"transSec.OffersAreAvailable": "Offers are available",
	"transSec.NoOffersAvailable": "No offers available",
	"transSec.AfterPaymentYouNeedToComeBackToConfirmThePaymentResultToEnsureThatThePurchaseContentIsSmoothlyDistributed": "After payment, you need to come back to confirm the payment result to ensure that the purchase content is smoothly distributed!",
	"transSec.PaymentAmount": "Payment amount",
	"transSec.Coupons": "Coupons",
	"transSec.IHaveReadAndAgree": "I have read and agree",
	"transSec.GotIt": "Got it",
	"transSec.ToPayForThisOrderPleasePayInTheOrderLogisticsOfTheCallPublicAccount": "To pay for this order, please pay in the order logistics of the [Call] public account",
	"transSec.RequestPaymentIn": "Request payment in...",
	"transSec.MarketplaceOrderConfirmationPagecouponClick": "Marketplace order confirmation page_coupon click",
	"transSec.abandon": "abandon"
}